jQuery(function(){

  //Scrollで要素表示した時点でclassを追加
  const sections = Array.prototype.slice.call(document.getElementsByClassName('js-addClass'));
  const waypoints = sections.map(section => {
    return new Waypoint({
      element: section,
      handler: function(direction) {
        section.classList.add('is-active');
        var nextEle = section.nextElementSibling;
        if(nextEle !== null){
          if(nextEle.classList.contains('js-addClass02')){
            setTimeout(function(){
              nextEle.classList.add('is-active');
            },200);
          }
        }
      },
      offset: '90%'
    });
  });



  function sticky(){

    let stickyFlag = true;
    let stickyWrapTop = [];
    let stickyDomain = [];
    let stickyHeading;

    const stickyWrap = document.querySelectorAll('.js-sticky__item__wrapper');
    //const stickyItem = document.querySelectorAll('.js-sticky__item');
    let stickyItem = [];
    let scrollTop = $(window).scrollTop();

    for (let i = 0; i < stickyWrap.length; i++) {

      stickyItem = stickyWrap[i].getElementsByClassName('js-sticky__item');
      stickyHeading = stickyWrap[i].querySelector('.js-sticky__heading');

      if(stickyFlag){
        stickyWrapTop[i] = window.pageYOffset + stickyWrap[i].getBoundingClientRect().top;
        stickyDomain[i] = stickyWrapTop[i] + stickyWrap[i].clientHeight - 100;
        for (let j = 0; j < stickyItem.length; j++) {
          if(j = stickyItem.length - 1){
            stickyDomain[i] = stickyDomain[i] - stickyItem[j].clientHeight;
          }
        }
      }
      

      
      if (scrollTop < stickyWrapTop[i]) { // sticky 領域に入っていないとき
          stickyHeading.style.top = '32px';
      } else { // sticky 領域に入ったとき
        if(scrollTop > stickyDomain[i]){ // sticky 領域を越えたとき
          let pos = stickyDomain[i] - window.scrollY + 32;
          stickyHeading.style.top = pos + 'px';
        }
      }
    }
    stickyFlag = false;
  }


  //スムーススクロール
  $('a[href^="#"]').on('click', function () {
    var speed = 1000;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({
      scrollTop: position
    }, speed, "swing");
    return false;
  });

  function domFinished(){
    document.body.classList.add('is-loaded');
  }
  
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", domFinished, false);
  } else {
    domFinished();
  }

  $(window).on('load scroll resize', function () {
    sticky();
  });

});
